import { IConfigGeralModulos } from "../../../Interfaces/Geral/ConfigGeral/ConfigGeral";
import Axios from "../../Config/API";
import Service from "../../Service";

export async function AtualizarConfigModuloService(
    requestBody: IConfigGeralModulos
) {
    return Service(
        Axios.put(`/home/configmodulo/atualizarconfigmodulo`, requestBody)
    );
}

export async function GetConfigModuloService(idModulo: number) {
    return Service(
        Axios.get<IConfigGeralModulos>(
            `/home/configmodulo/getconfigmodulo?idModulo=${idModulo}`
        )
    );
}

export async function ListConfigModuloService() {
    return Service(
        Axios.get<Array<IConfigGeralModulos>>(
            `/home/configmodulo/listconfigmodulo`
        )
    );
}
